import React, { useState } from "react";
import { FiMail, FiPhoneCall, FiMapPin, FiZap, FiArrowUpRight, FiCheckCircle } from "react-icons/fi";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    authorization: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [phoneError, setPhoneError] = useState("");

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (name === "phone") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prevState) => ({ ...prevState, phone: digitsOnly }));
      if (phoneError) setPhoneError("");
      return;
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? e.target.checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      setPhoneError("Please enter a valid 10-digit mobile number starting with 6-9.");
      return;
    }

    if (!formData.authorization) {
      alert("Please authorize notifications to proceed");
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    const payload = {
      sheetName: 'Contact Us',
      formType: 'Contact Us',
      fullName: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject || 'Contact Us Inquiry',
      message: formData.message,
      authorization: formData.authorization ? 'Yes' : 'No',
      position: formData.subject || 'Contact Us Inquiry',
      about: formData.message,
    };

    try {
      await fetch('/api/submit-application', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error('Contact submission error:', err);
    } finally {
      setIsSubmitting(false);
      setSubmitStatus("success");

      setTimeout(() => {
        setSubmitStatus(null);
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
          authorization: false,
        });
      }, 3500);
    }
  };

  return (
    <div className="contact-page">
      {/* Dynamic Background Elements */}
      <div className="bg-glow orb-1"></div>
      <div className="bg-glow orb-2"></div>
      <div className="bg-grid"></div>

      <div className="contact-container">
        <div className="contact-header">
          <h1 className="gradient-text">Contact Us</h1>
          <p>Get in touch with our tech engineering team for custom web, mobile, fintech, or cloud solutions.</p>
        </div>

        <div className="contact-content">
          <div className="contact-info fade-in-left">
            <h2>Talk to Our Tech Leads</h2>
            <p>
              Our team is here to answer your questions, evaluate your project architecture, and provide tailored technology solutions for your business.
            </p>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon"><FiMail /></div>
                <div className="contact-text">
                  <h3>Email Us</h3>
                  <p>kubersetu@gmail.com</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon"><FiPhoneCall /></div>
                <div className="contact-text">
                  <h3>Call / WhatsApp</h3>
                  <p>+91 9660236005</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon"><FiMapPin /></div>
                <div className="contact-text">
                  <h3>Corporate Office</h3>
                  <p>88-E, 2nd Floor, Near Punjab and Sind Bank, Jindal Chowk, Hisar, Haryana - 125001</p>
                </div>
              </div>
            </div>

            <div className="contact-trust-card">
              <div className="trust-icon"><FiZap /></div>
              <div>
                <h4>Fast Turnaround Guarantee</h4>
                <p>We typically respond within <strong>2 business hours</strong>. All inquiries are covered under our strict NDA & IP protection policy.</p>
              </div>
            </div>
          </div>

          <div className="contact-form-container fade-in-right">
            <h2 className="form-title">Send Us a Message</h2>
            <p className="form-subtitle">Fill in the details below and a lead engineer will reach out to you.</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group floating">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder=" "
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Full Name *</label>
                  <div className="input-highlight"></div>
                </div>

                <div className="form-group floating">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder=" "
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="email">Email Address *</label>
                  <div className="input-highlight"></div>
                </div>
              </div>

              <div className="form-group floating">
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  maxLength="10"
                  placeholder=" "
                  value={formData.phone}
                  onChange={handleChange}
                  className={phoneError ? 'input-error' : ''}
                  required
                />
                <label htmlFor="phone">Phone Number (10 digits) *</label>
                <div className="input-highlight"></div>
                {phoneError && <span className="error-text">{phoneError}</span>}
              </div>

              <div className="form-group floating">
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder=" "
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="subject">Subject / Project Type *</label>
                <div className="input-highlight"></div>
              </div>

              <div className="form-group floating">
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  placeholder=" "
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <label htmlFor="message">Your Message / Requirements *</label>
                <div className="input-highlight"></div>
              </div>

              <div className="form-group checkbox-group">
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="authorization"
                    name="authorization"
                    checked={formData.authorization}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="authorization" className="checkbox-label">
                    I authorize <strong>Kubersetu Infotech</strong> to contact me via Email, Call, SMS, or WhatsApp regarding this inquiry.
                  </label>
                </div>
              </div>

              <button
                type="submit"
                className={`submit-button ${isSubmitting ? "submitting" : ""}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="btn-content">Sending Inquiry...</span>
                ) : (
                  <span className="btn-content">Send Message <FiArrowUpRight className="btn-icon" /></span>
                )}
                <div className="btn-glow"></div>
              </button>

              {submitStatus === "success" && (
                <div className="success-message slide-up">
                  <span className="success-icon"><FiCheckCircle /></span>
                  Thank you! Your message has been sent. Our team will contact you shortly.
                </div>
              )}
            </form>
          </div>
        </div>

        <div className="faq-section fade-in-up">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item hover-lift">
              <h3>How quickly can we start a project?</h3>
              <p>
                After initial consultation and scope alignment, we can assign a dedicated engineering team and begin kickoff within 24 to 48 hours.
              </p>
            </div>

            <div className="faq-item hover-lift">
              <h3>Do you sign an NDA before project discussions?</h3>
              <p>
                Yes, absolutely. We prioritize your confidentiality and provide a signed Non-Disclosure Agreement (NDA) before reviewing sensitive specs or data.
              </p>
            </div>

            <div className="faq-item hover-lift">
              <h3>What tech stack do you specialize in?</h3>
              <p>
                We build high-performance web applications with React, Next.js, and Tailwind CSS, mobile apps with Flutter/React Native, and robust backends with Node.js, Python, and AWS/Cloud infrastructure.
              </p>
            </div>

            <div className="faq-item hover-lift">
              <h3>What is your support and maintenance policy?</h3>
              <p>
                All delivered software includes complimentary post-launch support, code documentation, bug fixes, and optional SLA-backed ongoing maintenance agreements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;